import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { PurposeService } from '../../../services/purpose.service';


@Component({
  selector: 'app-purpose-picker',
  templateUrl: './purpose-picker.component.html',
  styleUrls: ['./purpose-picker.component.scss']
})
export class PurposePickerComponent implements OnInit, OnChanges {
  @Input() purposeId: number;
  @Input() _placeholder: string = 'Please Select';
  @Output() onPurposeIdSet = new EventEmitter<number>();
  @Output() onPurposeSet = new EventEmitter<any>();

  purposes = [];


  constructor(public purposeService: PurposeService) {
  }

  ngOnInit(): void {
    this.purposeService.getAll().then((purposes) => {
      console.log(purposes);
      this.purposes = purposes;

      if (this.purposeId != undefined && this.purposeId != undefined) {
        var purpose = this.purposes.find(a => a.id == this.purposeId);
        this._placeholder = purpose.purpose;

      }
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.purposeId != null && changes.purposeId.currentValue != null)) {
    
      if ((this.purposeId != undefined && this.purposeId != undefined)&&(this.purposes != undefined && this.purposes != undefined)) {
        var purpose = this.purposes.find(a => a.id == this.purposeId);
        this._placeholder = purpose.purpose;

      }
    
    }
  }

  onChanged(purpose) {
    if (purpose) {
      this.onPurposeIdSet.emit(purpose.id);
      this.onPurposeSet.emit(purpose);
    }

  }

}
